import { render, staticRenderFns } from "./ReservationModal.vue?vue&type=template&id=72b94fb6&"
import script from "./ReservationModal.vue?vue&type=script&lang=js&"
export * from "./ReservationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports